import Request from '@/plugins/request';

export function getWarehouseGoods(params) {
  return Request.get('warehouse-goods', { params })
}

export function createWarehouseGood() {
  return Request.get(`warehouse-goods/create`)
}

export function storeWarehouseGood(data) {
  return Request.post('warehouse-goods', data)
}

export function updateWarehouseGood(id, data) {
  return Request.put(`warehouse-goods/${id}`, data)
}

export function editWarehouseGood(id) {
  return Request.get(`warehouse-goods/${id}/edit`)
}

export function destroyWarehouseGood(id) {
  return Request.delete(`warehouse-goods/${id}`)
}
